import { getFormatMessage } from '@/utils/utils'
import { Table, Tag } from 'antd'
import React from 'react'
import { FirmwareItem, FirmwareTableProps } from '../interface'

export const FirmwareTable: React.FC<FirmwareTableProps> = (
  props: FirmwareTableProps
) => {
  const formatMessage = getFormatMessage()
  const columns = [
    {
      title: formatMessage({ id: 'app.firmware.table.index' }),
      key: 'index',
      render: (text: any, record: any, index: any) => index + 1
    },
    {
      title: formatMessage({ id: 'app.firmware.table.mainVer' }),
      dataIndex: 'mainVer',
      key: 'mainVer'
    },
    {
      title: formatMessage({ id: 'app.firmware.table.verDetail' }),
      dataIndex: 'verDetail',
      key: 'verDetail'
    },
    {
      title: formatMessage({ id: 'app.firmware.table.boxTypes' }),
      key: 'boxTypes',
      render: (text: any, record: FirmwareItem, index: any) => {
        return record.boxTypes?.map((x) => (
          <Tag key={x}>{formatMessage({ id: `app.boxType.${x}` })}</Tag>
        ))
      }
    },
    {
      title: formatMessage({ id: 'app.firmware.table.remark' }),
      dataIndex: 'remark',
      key: 'remark'
    }
  ]

  return (
    <Table
      rowKey='mainVer'
      columns={columns}
      dataSource={props.data}
      pagination={props.pagination}
    />
  )
}
